import React from 'react';
import { Link } from 'react-router-dom';

import './product-type-box.scss';



///////////////////////////////////////////////
///////////                         ///////////
///////////    Types' categories    ///////////
///////////                         ///////////
///////////////////////////////////////////////
// const historicalCategories = [
//    'Younger Children',
//    'Children',
//    'Young Adults / Adults'
// ];

// const theologyCategories = [
//    'Bible Study Material',
//    'Doctrine',
//    'Christian Life & Pastoral Care',
//    'Church History',
//    'Meditations & Sermons'
// ];

// const mediaCategories = [
//    'CD',
//    'DVD',
//    'Sheet Music'
// ]
///////////////////////////////////////////////
///////////////////////////////////////////////


/**
 * Pproduces the information for each existing categories of a specifiv type
 * 
 * @param {array} categories 
 */
// function returnList(categories) {
//    let list = categories.map(value => {
//       return <li key={value}>{value}</li>
//    });

//    return list;
// }

/**
 * Calls the returnList() method based on the product type
 * 
 * @param {string} type 
 */
// function getList(type) {
//    switch(type) {
//       case 'historical':
//          return returnList(historicalCategories);
//       case 'theology':
//          return returnList(theologyCategories);
//       case 'media':
//          return returnList(mediaCategories);
//       default:
//          console.error(`Unexpected type: ${type}`);
//          return null;
//    }
// }

/**
 * ProductTypeBox Component
 * It shows the various subjects of the products
 * 
 * @param {object} props The component's properties
 */
const ProductTypeBox = props => {

   const handleLinks = filter => {
      props.setFilter(filter);
      props.updateLastProductPage(1);
   }

   return (
      <div className="row justify-content-center align-items-center product-type-box">
         <div className="ptb-title">
            <h3>{props.title}</h3>
         </div>
         <div className="ptb-line"></div>
         <div className="ptb-category">
            <ul>
               {
                  props.categories.map((cat, index) => {
                     return (
                        <Link key={index} to="/products" onClick={() => handleLinks(cat)}>
                           <li key={cat} style={index !== 0 ? {marginTop:'.7rem'} : {}}>{cat}</li>
                        </Link>
                     )
                  })
               }
            </ul>
         </div>
      </div>
   )
}

export default ProductTypeBox;